import { useQuery } from '@tanstack/react-query';
import type { NotificationsSearchRequestQuery, NotificationsSearchResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';
import { NotificationKeys } from '@services/notification/keys';
import { config } from '@services/config';

const getQueryParams = (params: NotificationsSearchRequestQuery) => {
  const query = new URLSearchParams();

  const { pageLimit, pageOffset, sort, quoteId, policyId, userRoleType } = params;

  if (pageLimit !== undefined) {
    query.append('pageLimit', String(pageLimit));
  }

  if (pageOffset !== undefined) {
    query.append('pageOffset', String(pageOffset));
  }

  if (sort !== undefined) {
    query.append('sort', String(sort));
  } else {
    // default newest first
    query.append('sort', '-emailNotification.sentAt');
  }

  if (quoteId) {
    query.append('quoteId', String(quoteId));
  }
  if (policyId) {
    query.append('policyId', String(policyId));
  }
  if (userRoleType) {
    query.append('userRoleType', String(userRoleType));
  }

  return query.toString();
};

export const useSearchNotifications = (params: NotificationsSearchRequestQuery, enabled: boolean = true) => {
  const client = useClient();
  const query = getQueryParams(params);
  const queryString = query ? `?${query}` : '';

  const result = useQuery<NotificationsSearchResponse>({
    queryKey: NotificationKeys.searchNotifications(params),
    queryFn: () => client.get(`notification${queryString}`).json<NotificationsSearchResponse>(),
    enabled,
    ...config,
  });

  return { ...result, notifications: result.data };
};
